import React, { useEffect } from 'react';
import { CONSENTS_FLOW } from '../../../../shared/onboardingConstants';
import { analyticsPageName, t } from '../../../../shared/onboardingUtils';
import useNavigateToNextStep from '../../../../shared/useNavigateToNextStep';
import { useOnboardingContext } from '../../../../state/OnboardingContext';
import ActionButton, { ACTIONS } from '../../../ActionButton/ActionButton';
import ModalBodyWithAlerts from '../../../ModalBodyWithAlerts';
import OnboardingModalActions from '../../../OnboardingModalActions';

import styles from './HealthDenialOne.scss';

const HealthDenialOne = () => {
  const { state, dispatch, track } = useOnboardingContext();
  const { alert } = state;

  useEffect(() => {
    track({
      page: analyticsPageName(CONSENTS_FLOW.health_denial_one),
      action: 'screen_enter'
    });
  }, [track]);

  const { stepForward, isProcessing } = useNavigateToNextStep({
    state,
    dispatch,
    track
  });

  return (
    <>
      <ModalBodyWithAlerts alert={alert}>
        <h2>{t('consents.health_denial_one.header')}</h2>
        <p>{t('consents.health_denial_one.description')}</p>
      </ModalBodyWithAlerts>
      <OnboardingModalActions>
        <ActionButton
          variant="default"
          onClick={() => stepForward({ action: ACTIONS.cancel })}
          data-cy="health-denial-one-cancel-next-step-btn"
          className={styles.actionButton}
          focus={true}
        >
          {t('cta_actions.cancel')}
        </ActionButton>
        <ActionButton
          variant="primary"
          onClick={() => stepForward({ action: ACTIONS.deny })}
          data-cy="health-denial-one-deny-next-step-btn"
          isProcessing={isProcessing}
          className={styles.actionButton}
        >
          {t('cta_actions.deny_permission')}
        </ActionButton>
      </OnboardingModalActions>
    </>
  );
};

export default HealthDenialOne;
